// @TODO: menu not working on web
/**
 * Ryan O'Dowd
 * 2023-01-01
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import Header from '@components/Header';
import Menu from '@components/common/Menu';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const LocaleMenuButton = (props: LocaleMenuButtonProps) => {
  const styles = hooks.useStyles(getStyles);
  const [_isLocaleMenuOpen, setIsLocaleMenuOpen] = useState(false);

  const locales = hooks.useTypedSelector((state) => Object.values(state.locales), (oldValue, newValue) => JSON.stringify(oldValue) === JSON.stringify(newValue));

  // @TODO: get these options from redux
  return ( // @TODO: only display options that are supported...if only one option, don't display menu (tibbits)
    <Menu
      statusBarHeight={styles.safeAreaInsets.top}// @TODO: abstract menu to oak component and abstract this prop away
      anchor={
        <Header.Icon
          icon='translate'
          onPress={() => setIsLocaleMenuOpen(true)}
        />
      }
      visible={_isLocaleMenuOpen}
      onDismiss={() => setIsLocaleMenuOpen(false)}
    >
      {locales.map((locale: any) => {
        return (
          <Menu.Item
            key={locale.id}
            title={<Text style={props.localeId === locale.id ? styles.bold : {}}>{locale.language_name_local}</Text>}
            onPress={() => {
              props.setLocaleId(locale.id);
              setIsLocaleMenuOpen(false);
            }}
          />
        );
      })}
    </Menu>
  );
};

class LocaleMenuButtonProps {
  localeId: any;
  setLocaleId: any;
};

export default LocaleMenuButton;
